import * as React from 'react'
import { memo } from 'react'
import { Helmet } from 'react-helmet'

export default memo((props) => {
	const { 0: title, 1: description, 2: keywords, 3: url, 4: logo } = props
	return (
		<Helmet>
			<title>{title}</title>
			<meta name="description" content={description} />
			<meta name="keywords" content={keywords} />			
			<meta property="og:url" content={`https://www.inmusicbrands.com${url}`} />
			<meta property="og:type" content='website' />
			<meta property="og:title" content={title} />
			<meta property="og:description" content={description} />
			<meta property="og:image" content={logo} />
			<meta name="twitter:card" content='summary_large_image' />
		</Helmet>
	)
})